import gql from "graphql-tag";

export interface ObservatoryBundleItem {
  id: string;
  name: string;
}

export interface ObservatoryBundle {
  id: string;
  name: string;
  createdAt: string;
  isActive: boolean;
  description: string;
  marketArrayReport: ObservatoryBundleItem;
  observatoryReport: ObservatoryBundleItem;
  insightsReport: ObservatoryBundleItem;
  drilldown: ObservatoryBundleItem;
  roles: string[];
}

export interface ObservatoryBundleInput {
  name: string;
  description: string;
  isActive: boolean;
  roles: string[];
  marketArrayReportId?: string;
  observatoryReportId?: string;
  insightsReportId?: string;
  drilldownId?: string;
}

export interface CreateObservatoryBundleVariables {
  observatoryBundle: ObservatoryBundleInput;
}

export interface UpdateObservatoryBundleVariables {
  id: string;
  observatoryBundle: ObservatoryBundleInput;
}

interface ObservatoryBundleResult {
  observatoryBundle: ObservatoryBundle;
  message: string;
  success: boolean;
}

export interface CreateObservatoryBundleResult {
  createObservatoryBundle: ObservatoryBundleResult;
}

export interface UpdateObservatoryBundleResult {
  updateObservatoryBundle: ObservatoryBundleResult;
}

export interface AdminGetObservatoryBundleVariables {
  id: string;
}

export interface AdminGetObservatoryBundleResult {
  adminGetObservatoryBundle: ObservatoryBundle;
}

export const observatoryBundleItemFieldsFragment = gql`
  fragment ObservatoryBundleItemFields on ObservatoryBundleItem {
    id
    name
  }
`;

export const observatoryBundleFieldsFragment = gql`
  fragment ObservatoryBundleFields on ObservatoryBundle {
    id
    name
    createdAt
    isActive
    description
    roles
    marketArrayReport {
      ...ObservatoryBundleItemFields
    }
    observatoryReport {
      ...ObservatoryBundleItemFields
    }
    insightsReport {
      ...ObservatoryBundleItemFields
    }
    drilldown {
      ...ObservatoryBundleItemFields
    }
  }
  ${observatoryBundleItemFieldsFragment}
`;

export const observatoryBundleResponseFragment = gql`
  fragment ObservatoryBundleResponseFields on ObservatoryBundleResponse {
    observatoryBundle {
      ...ObservatoryBundleFields
    }
    message
    success
  }
  ${observatoryBundleFieldsFragment}
`;

export const observatoryBundleQuery = gql`
  query observatoryBundle($id: String) {
    observatoryBundle(id: $id) {
      ...ObservatoryBundleFields
    }
  }
  ${observatoryBundleFieldsFragment}
`;

export const createObservatoryBundleMutation = gql`
  mutation createObservatoryBundle(
    $observatoryBundle: ObservatoryBundleInput!
  ) {
    createObservatoryBundle(observatoryBundle: $observatoryBundle) {
      ...ObservatoryBundleResponseFields
    }
  }
  ${observatoryBundleResponseFragment}
`;

export const updateObservatoryBundleMutation = gql`
  mutation updateObservatoryBundle(
    $id: String!
    $observatoryBundle: ObservatoryBundleInput!
  ) {
    updateObservatoryBundle(id: $id, observatoryBundle: $observatoryBundle) {
      ...ObservatoryBundleResponseFields
    }
  }
  ${observatoryBundleResponseFragment}
`;

export const adminGetObservatoryBundleQuery = gql`
  query adminGetObservatoryBundle($id: String!) {
    adminGetObservatoryBundle(id: $id) {
      ...ObservatoryBundleFields
    }
  }
  ${observatoryBundleFieldsFragment}
`;
